module.exports = __webpack_public_path__ + "img/banner-ja.7e99e156.png";